module.exports = __webpack_public_path__ + "img/Vector22.47cc3391.svg";